(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header-plus"] && !window.DesignMode) return;
  try {
    
    let lastScroll = -1
    function initialize(){
      
        const headerWrapper = document.querySelector('.header-plus-wrapper');
        const headerPlus = headerWrapper.querySelector(".header-plus");
        const shoppingCartCount = headerPlus.querySelector(".shopping-cart-count")
        function updateShoppingCartCount(){
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json(), err => ({}))
            .then(json => shoppingCartCount.textContent = json.item_count || '');
        }
        setInterval(updateShoppingCartCount, 5000);
        updateShoppingCartCount();
      
        [...document.querySelectorAll('.header-plus')].forEach(hg => {
          const headerGroup = hg.closest(".shopify-section-group-header-group")
          if (headerGroup) {
            headerGroup.classList.add('sticky-header-group')
          }
        });
        document.addEventListener("scroll", (event) => {
          if (!headerWrapper){
            return
          }
          if (window.scrollY < lastScroll && window.scrollY < 10){
            headerWrapper.dataset.scrolled = "false"
            headerPlus.dataset.scrolled = "false"
          } else if (window.scrollY > lastScroll && window.scrollY > 10) {
            headerWrapper.dataset.scrolled = "true"
            headerPlus.dataset.scrolled = "true"
          }
          lastScroll = window.scrollY;
        });

        //Predictive search
        const predictiveSearch = document.querySelector('.predictive-search-box')
        if (predictiveSearch){
          const predictiveSearchDisplay = document.querySelector('.predictive-search-display')
          const predictiveSearchInput = predictiveSearch.querySelector('input.predictive-search-field')
          const predictiveSearchResults = predictiveSearchDisplay.querySelector('.predictive-search-results')
          predictiveSearch.addEventListener('click', (event) => {
            const previous = predictiveSearch.dataset.open
            if (previous == 'true' && event.target.closest('.predictive-search-icon')) {
              predictiveSearchDisplay.dataset.open = "false"
              predictiveSearch.dataset.open = 'false'
            } else {
              predictiveSearchDisplay.dataset.open = "true"
              predictiveSearch.dataset.open = 'true'
              predictiveSearchInput.focus()
            }
          })
          document.addEventListener('click', (event) => {
            if(!predictiveSearch.contains(event.target) && !predictiveSearchDisplay.contains(event.target)){
              predictiveSearch.dataset.open = "false"
              predictiveSearchDisplay.dataset.open = "false"
        	}
          });
          const updateReference = {}
          if (predictiveSearchInput){
              predictiveSearchInput.addEventListener('input', (event) => {
                if (updateReference.scheduled){
                  clearTimeout(updateReference.scheduled)
                }
                updateReference.scheduled = setTimeout(() => {
                  onPropegateSearchResults(predictiveSearchInput.value.trim(), predictiveSearchResults)
                  updateReference.scheduled = undefined
                }, 300)
              });
              predictiveSearchInput.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                  window.location.assign(`${window.location.origin}/search?type=product&options[prefix]=last&q=${predictiveSearchInput.value}`)
                }
              });
          }
        }
    }

  
    function onPropegateSearchResults(searchTerm, displayArea) {
      const displayAreaContent = displayArea.querySelector('.predictive-search-results-content')
      if (!searchTerm || searchTerm.length == 0){
        displayArea.dataset.results = "false"
        displayAreaContent.innerHTML = '';
        return
      }
      fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search-plus`)
        .then((response) => {
          if (!response.ok) {
            displayArea.dataset.results = "false"
            displayAreaContent.innerHTML = '';
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          displayArea.dataset.results = "true"
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-plus').innerHTML;
          displayAreaContent.innerHTML = resultsMarkup;
        })
        .catch((error) => {
          displayArea.dataset.results = "false"
          displayAreaContent.innerHTML = '';
          throw error;
        });
    }
  
  initialize()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-plus"] && !window.DesignMode) return;
  try {
    
    let heros = new Map()

    function activateItem(hero, id, countdownOverride){
        const config = heros.get(hero)
        if (!config){
          return
        }
        config.currentHeroCountdown = countdownOverride || 7000
        if (hero == undefined || id == undefined){
          return
        }
        const heroElement = document.querySelector(`.hero-base[data-hero="${hero}"]`)
        if (heroElement) {
          [...heroElement.querySelectorAll("[data-hero-item]")].forEach(heroItem => {
            if (heroItem.dataset.heroItem == id){
              heroItem.dataset.active = "true"
            } else {
              heroItem.dataset.active = "false"
            }
          });
        }
    }
  
    function heroParallax(hero){
    }

    function heroHeartbeat(id){
      const config = heros.get(id)
      if (!config){
        return
      }
      const currentHeartbeat = Date.now()
      config.currentHeroCountdown -= currentHeartbeat - config.lastHeartbeat;
      if (config.currentHeroCountdown <= 0) {
        config.currentHero = config.currentHero != undefined ? config.currentHero + 1 : 0;
        if (config.currentHero >= config.herosItems.length){
          config.currentHero = 0;
        }
        activateItem(id, config.heroIds.at(config.currentHero));
      }
      config.lastHeartbeat = currentHeartbeat;
    }

    function initialize(){
      let herosSections = [...document.querySelectorAll(".hero-base[data-hero]")]
      let heroConfiguration = []
      for (const hero of herosSections){
        let heroConfig = {
          id: hero.dataset.hero,
          herosItems: [],
          heroIds: [],
          currentHero: undefined,
          currentHeroCountdown: 0,
          lastHeartbeat: Date.now(),
          herosItems: [...hero.querySelectorAll(".hero-item[data-hero-item]")],
          heroIds: undefined,
        }
        
        heroConfig.heroIds = heroConfig.herosItems.map(h => h.dataset.heroItem);
        heros.set(heroConfig.id, heroConfig)
        //Connect Hero Buttons
        for (const id of heroConfig.heroIds) {
          const button = document.querySelector(`button[data-hero-item="${id}"]`)
          if (button){
            button.addEventListener('click', (event) => {
              activateItem(heroConfig.id, id, 7500)
            })
          }
        }
        //Connect Timer
        setInterval(heroHeartbeat, 100, heroConfig.id)
        //Connect Paralax
        for(const heroItem of heroConfig.herosItems) {
          if (heroItem.dataset.parallax == 'true'){
            document.addEventListener("mousemove", (event) => {
              heroParallax(heroItem, event.clientX, event.clientY)
            })
          }
        }
      }
      setInterval(() => {
        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
      }, 5)
    }

  initialize()

  } catch(e) { console.error(e); }
})();
      })();
